import React from 'react';
import icons from '../../assets/icons';
import './styles.scss';
import Footer from '../../components/footer';

const Maintenance = ({ isWhitelabel }) => (
  <div className={`maintenance-screen ${isWhitelabel ? '' : 'display-logo'}`}>
    <div className="content">
      <img className="warning-icon" src={icons['warning']} />
      <div className="info">
        <h1>Scheduled Maintenance in Progress</h1>
        <h2>
          The application will be back online shortly.
          <br />
          All devices remain active and will continue collecting data as normal.
          <br />
          No data will be lost or altered during this maintenance window.
        </h2>
      </div>
      <div className="info-small">
        <p>Thank you for your patience</p>
        <p>Admobilize Team</p>
        <a href="/#/logout">Log out</a>
      </div>
    </div>
    <Footer />
  </div>
);

export default Maintenance;
